import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import storage from "../../Assets/js/Global";
import { images } from "../../Assets/images";
import { Link } from "react-router-dom";

const Login = () => {
  const {
    checkUserRegistration,
    fourLifeSSOLogin,
    userData,
    updateUserData,
    translatedLabels,
    logoUrl,
    is4Life,
  } = useContext(GlobalContext);

  const authLabel = translatedLabels?.auth;
  const [showEmailInput, setShowEmailInput] = useState(!is4Life);
  const loginWithGoogle = async () => {
    if (window?.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("googleSignIn");
    } else {
      try {
        // Load Firebase only when the user actually chooses social sign-in, so
        // it stays out of the initial login-screen bundle.
        const [{ auth, googleProvider }, { signInWithPopup }] = await Promise.all([
          import("../../firebase"),
          import("firebase/auth"),
        ]);
        const result = await signInWithPopup(auth, googleProvider);
        const token = await result.user.getIdToken();
        if (window.loginWithGoogle) {
          window.loginWithGoogle(token);
        }
      } catch (error) {
        // User dismissed the popup — not a real error, so stay silent.
        if (
          error?.code === "auth/popup-closed-by-user" ||
          error?.code === "auth/cancelled-popup-request"
        ) {
          return;
        }
        console.error("Firebase Google Login Error:", error);
        window.showToast?.("error", error?.message || authLabel?.google_login_failed?.label_value || "Google Login failed");
      }
    }
  };

  const loginWithApple = async () => {
    if (window?.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("appleSignIn");
    } else {
      try {
        // Load Firebase only when the user actually chooses social sign-in, so
        // it stays out of the initial login-screen bundle.
        const [{ auth, appleProvider }, { signInWithPopup }] = await Promise.all([
          import("../../firebase"),
          import("firebase/auth"),
        ]);
        const result = await signInWithPopup(auth, appleProvider);
        const token = await result.user.getIdToken();
        if (window.loginWithApple) {
          window.loginWithApple(token);
        }
      } catch (error) {
        // User dismissed the popup — not a real error, so stay silent.
        if (
          error?.code === "auth/popup-closed-by-user" ||
          error?.code === "auth/cancelled-popup-request"
        ) {
          return;
        }
        console.error("Firebase Apple Login Error:", error);
        window.showToast?.("error", error?.message || authLabel?.apple_login_failed?.label_value || "Apple Login failed");
      }
    }
  };

  useEffect(() => {
    storage.remove("UserModule");
    // Coming back from the password / forgot-password flow: the field was
    // cleared after "Next", so refill it with the email the user already used.
    const storedEmail = storage.get("verifiedEmail");
    if (storedEmail && !userData?.email) {
      updateUserData("email", storedEmail);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    checkUserRegistration();
  };

  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const companyId = process.env.REACT_APP_COMPANY_ID;
  const fallbackLogo =
    companyId === "wu9zm8"
      ? images.brasilLogo
      : companyId === "8nn29"
        ? images.globalHealthLogo
        : images.appLogo;
  const [logoSrc, setLogoSrc] = useState(fallbackLogo);

  useEffect(() => {
    if (!logoUrl) return;
    const img = new Image();
    img.onload = () => setLogoSrc(logoUrl);
    img.onerror = () => setLogoSrc(fallbackLogo);
    img.src = logoUrl;
  }, [logoUrl]);

  return (
    <section className="login-wrapper">
      <div className="login-card">
        <div className="text-center mb-3">
          <img
            src={logoSrc}
            alt="app-logo"
            className="login-logo"
            style={is4Life ? { width: "190px", height: "70px" } : {}}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = fallbackLogo;
            }}
          />
        </div>

        <h3 className="text-center mb-3">
          {authLabel?.welcome_back?.label_value || "Welcome Back!"}
        </h3>

        {is4Life && !showEmailInput ? (
          <div className="mt-3 pt-2 d-grid gap-3">
            <button
              type="button"
              className="btn btn-primary"
              onClick={fourLifeSSOLogin}
            >
              {authLabel?.already_4life_member?.label_value ||
                "Continue with your 4Life account"}
            </button>
            {/* <Link
              to="/qr-scanner"
              className="btn   text-muted"
            >
              {authLabel?.continue_as_guest?.label_value || "Continue as Guest"}
            </Link> */}
          </div>
        ) : (
          <>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">
                  {authLabel?.login_signup?.label_value || "Login / Signup"}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  className="form-control"
                  placeholder={
                    authLabel?.enter_your_email?.label_value ||
                    "Enter your email"
                  }
                  value={userData.email}
                  onChange={(e) => updateUserData("email", e.target.value)}
                />
              </div>

              <div className="d-flex justify-content-center">
                <div>
                  <button type="submit" className="btn btn-primary mt-3">
                    {authLabel?.next?.label_value || "Next"}
                  </button>
                </div>
              </div>
            </form>
          </>
        )}

        {!is4Life && (
          <>
            <div className="divider my-4 text-center">
              <span>{authLabel?.or?.label_value || "OR"}</span>
            </div>

            <div className="d-flex justify-content-center">
              <div className="app-button mx-2" onClick={loginWithGoogle}>
                <img
                  className="me-1"
                  src={images.googleIcon}
                  style={{ width: "18px" }}
                  alt="Google"
                />
                {authLabel?.google?.label_value || "Google"}
              </div>

              <div className="app-button mx-2" onClick={loginWithApple}>
                <img
                  className="me-1"
                  src={images.appleIcon}
                  style={{ width: "18px" }}
                  alt="Apple"
                />
                {authLabel?.apple?.label_value || "Apple"}
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default Login;
